// import { openReportViewerDialog } from '../store/reportViewDialogReducer';
import { usePermission } from '@fuse/hooks';



function DynamicFieldsHeader(props) {


	const { hasPermission } = usePermission()


	return (
		<div className="flex flex-1 w-full items-center justify-between">
		</div>
	)
}

export default DynamicFieldsHeader;
